import { ResendConfirmationEmailMessages, TranslationResendConfirmationEmailMessages } from "@languages/interfaces";

export const messages: TranslationResendConfirmationEmailMessages = {
  [ResendConfirmationEmailMessages.resendConfirmationEmailRequiredEmail]: "Email is required",
  [ResendConfirmationEmailMessages.resendConfirmationEmailInvalidEmail]: "Invalid email",
  [ResendConfirmationEmailMessages.resendConfirmationEmailTitlePage]: "Resend confirmation email",
  [ResendConfirmationEmailMessages.resendConfirmationEmailLabel]: "Email",
  [ResendConfirmationEmailMessages.resendConfirmationEmailButton]: "Send email"
};